import { useEffect, useState } from "react";
import cx from 'classnames';
import { useNavigate, useSearchParams } from "react-router-dom";
import { useMediaQuery } from "react-responsive";
import { ProgressBar } from "react-step-progress-bar";

import { CHAPTER_COMPLETE_PERCENTAGE, IS_POST_MODULE_ASSESSMENT_AVAILABLE, LMS_CHAPTER_ID, LMS_CHAPTER_NAME } from "../../../../utils/cookiesmanager";

import "react-step-progress-bar/styles.css";

import Module from "../../../../../src/assets/images/module-assessment-star-icon.svg";
import ModuleLock from "../../../../../src/assets/images/module-lock.svg";
import RightChevron from "../../../../../src/assets/images/right-chevron.svg";
import TickIcon from "../../../../../src/assets/images/tick-icon.png";

import HeaderModule from "../ModuleHeaderComponent";
import Shimmer from "../ShimmerComponent";

import { useGetChapterByModuleTypeKeys } from "./queries";
import { ChapterStatus } from "./constant";

import styles from "./styles.module.scss";
import CheckSvgComponent from "../CheckSvgComponent";

const ModuleChapterListUiComponent = () => {
  const [mobileOn, setMobileOn] = useState(false);

  const navigate = useNavigate();

  const [searchParams] = useSearchParams();
  const courseId = searchParams.get("courseId");
  const moduleId = searchParams.get("moduleId");
  const courseName = searchParams.get("courseName");
  const languageId = localStorage.getItem("l_id") || 1;
  const isPostModuleAssessmentAvailable = localStorage.getItem(IS_POST_MODULE_ASSESSMENT_AVAILABLE);

  const { data, isLoading } = useGetChapterByModuleTypeKeys({
    courseId,
    languageId,
    moduleId,
  });

  const modulesChapterData = data?.data?.response || {};
  const chaptersData = modulesChapterData?.chapters || [];
  const moduleDescriptionData =
    modulesChapterData?.moduleDescription?.[0] || {};
   
  const {postAssessment , feedback } = modulesChapterData || {};  

  console.log(postAssessment,'postAssessment');

  const onBackClick = () => {
    navigate(`/user/module-list?courseId=${courseId}&courseName=${courseName}`)
  }  

  const handleCourseContentRedirection = (chapterItem) => {
    localStorage.setItem(LMS_CHAPTER_ID,chapterItem?.chapterId);
    localStorage.setItem(LMS_CHAPTER_NAME,chapterItem?.chapterTitle);
    localStorage.setItem(CHAPTER_COMPLETE_PERCENTAGE,chapterItem?.chapterCompletePercentage);

    navigate(`/user/inclusive-course?courseId=${courseId}&moduleId=${moduleId}&chapterId=${chapterItem?.chapterId}&courseName=${courseName}`)
  }

  const handleModuleAssessmentRedirection = () => {
    if(feedback === 0 && postAssessment === 0){
      navigate(`/user/post-module-assessment?courseId=${courseId}&moduleId=${moduleId}&courseName=${courseName}`)
      return ;
    }
    else if(postAssessment === 1 && feedback === 0){
    navigate(`/user/post-module-feedback?courseId=${courseId}&moduleId=${moduleId}&courseName=${courseName}`);
    }
  }

  const isAllModulesCompleted =
    chaptersData?.length && chaptersData?.every((item) => item?.chapterCompletePercentage === "100%");

    const isCertificateEarned = postAssessment === 1 && feedback === 1;

const iconSrc =
  isAllModulesCompleted && feedback === 0
    ? RightChevron
    : ModuleLock;

  const renderStatusText = () => {
  if (isAllModulesCompleted && postAssessment === 0) {
    return (
      <p className={styles["start-assessment"]}>
        Start assessment
      </p>
    );
  }

  if (postAssessment === 1 && feedback === 1) {
    return (
      <p className={styles["start-chapter"]}>
        Certificate Earned
      </p>
    );
  }

  if (postAssessment === 1 && feedback === 0) {
    return <p  className={styles["start-assessment"]}>Give feedback</p>;
  }

  return (
    <p className={styles["certificate-subtitle"]}>
      Complete all chapter to unlock the assessment and earn your certificate.
    </p>
  );
   };

  const isSmallScreen = useMediaQuery({ query: "(max-width: 440px)" });

  useEffect(() => {
    setMobileOn(isSmallScreen);
  }, [isSmallScreen]);


  return (
    <>
      <HeaderModule title={`Module ${moduleId || 1}`} onBackClick={onBackClick} />

      <div className={styles["main-container"]}>
        {isLoading ? (
          <Shimmer
            width="100%"
            height="160px"
            borderRadius="16px"
            style={{ marginBottom: "20px" }}
          />
        ) : (
          <div className={styles["about-chapter-wrapper"]}>
            <div className={styles["module-content-container"]}>
              <div className={styles["module-content"]}>
                {moduleDescriptionData?.moduleTitle}
              </div>

              <div
                className={styles["module-content-description"]}
                dangerouslySetInnerHTML={{
                  __html: moduleDescriptionData?.moduleDescription || "",
                }}
              />
            </div>
          </div>
        )}

        <div className={styles["all-course-wrapper"]}>
          {isLoading
            ? [...Array(6)].map((_, index) => (
                <Shimmer
                  key={index}
                  width="100%"
                  height="90px"
                  borderRadius="12px"
                  style={{ marginBottom: "12px" }}
                />
              ))
            : chaptersData?.map((chapter , index) => (
                <div
                  key={chapter?.chapterId}
                  className={cx(styles["course-wrapper"], (chapter?.courseStatus === ChapterStatus.IN_PROCESS || chapter?.courseStatus ===ChapterStatus.COMPLETED) ? styles['cursor-pointer'] : styles['pointer-event'])}
                  role="button" 
                  tabIndex={0} 
                  onClick={()=>handleCourseContentRedirection(chapter)}
                >
                  <div className={styles.course}>
                                        
                    <div className={styles["course-id"]}>
                      {chapter?.chapterCompletePercentage === "100%" ? (
                        <img src={TickIcon} alt="Completed" />
                        ) : (
                        index + 1
                      )}
                    </div>

                    <div className={styles["course-description-wrapper"]}>
                      <div className={styles["course-description"]}>
                        {chapter?.chapterTitle}
                      </div>

                      {chapter?.courseStatus === ChapterStatus.IN_PROCESS && (
                        <div className={styles["progress-wrapper"]}>
                         {chapter?.chapterCompletePercentage === '0%' ?
                         <p className={styles['start-assessment']}>Start Learning</p> 
                         :
                         <>
                        <ProgressBar
                            percent={+chapter?.chapterCompletePercentage.replace('%','')}
                            filledBackground="linear-gradient(to right, #111E5B, #274CC3)"
                            width={mobileOn ? "75px" : "150px"}
                        />
                        <p className={styles.progress}>
                            {chapter?.chapterCompletePercentage}
                        </p>
                          </>
                        }
                        </div>
                      )}
                      {chapter?.courseStatus === ChapterStatus.COMPLETED && (
                        <div className={styles["progress-wrapper"]}>
                         {chapter?.chapterCompletePercentage === '100%' &&<p className={styles['start-chapter']}>Completed</p> }
                        </div>
                      )}
                    </div>
                  </div>

                  <img
                    className={styles.cursor}
                    src={
                      chapter?.courseStatus === ChapterStatus.LOCKED
                        ? ModuleLock
                        : RightChevron
                    }
                    alt="status"
                  />
                </div>
              ))}

          {isLoading ? (
            <Shimmer
              width="100%"
              height="100px"
              borderRadius="12px"
              style={{ marginTop: "12px" }}
            />
          ) : (
            isPostModuleAssessmentAvailable === '1'
            ?
            <div className={cx(styles["course-wrapper"],isAllModulesCompleted ? styles['cursor-pointer'] : styles['pointer-event'])} onClick={handleModuleAssessmentRedirection} >
              <div className={styles.course}>
                <img className={styles.cursor} src={Module} alt="assessment" />

                <div className={styles.certificate}>
                  <div className={styles["course-description"]}>
                    Module assessment
                  </div>
                  {renderStatusText()}
                </div>
              </div>
              {isCertificateEarned ? (
              <CheckSvgComponent width="24" className={styles.svg} />
           ) : (
              <img
             className={styles.cursor}
             src={iconSrc}
             alt="status-icon"
             />
)}
            </div>
            :null
          )}
        </div>
      </div>
    </>
  );
};

export default ModuleChapterListUiComponent;
